import { render, staticRenderFns } from "./changePaw.vue?vue&type=template&id=2c5202fe"
import script from "./changePaw.vue?vue&type=script&lang=js"
export * from "./changePaw.vue?vue&type=script&lang=js"
import style0 from "./changePaw.vue?vue&type=style&index=0&id=2c5202fe&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports